/// <amd-module name="Pipeline/Analytics/DurationMetricsTrendCard/DurationUtils" />
import { getTrendFromData } from "Analytics/Shared/Common/Utils/TrendCalculator";
import { DurationNormalizer } from "Analytics/Shared/TrendChart/Common/DurationNormalizer";
import { ITrendChartAggregateData, ITrendChartData } from "Analytics/Shared/TrendChart/Common/Types";
import { INormalizedDuration } from "Analytics/Shared/TrendChart/Common/Types";
import { SuccessfulPipelines } from "Pipeline/Analytics/Common/Constants";

export function normalizeDurationData(chartData: ITrendChartData) {
    const durationNormalizationHelper = new DurationNormalizer();
    let normalizedDuration: INormalizedDuration;
    const durationList: number[][] = [];

    Object.keys(chartData.primaryChartData).forEach(k => {
        durationList.push(chartData.primaryChartData[k].map(d => d.aggrValue));
    });

    normalizedDuration = durationNormalizationHelper.normalizeDurations(durationList, true);
    return normalizedDuration;
}

export function getNormalizedChartData(normalizedDuration: INormalizedDuration, succesfulPipelineData: ITrendChartAggregateData[]) {
    const updatedValues: number[] = normalizedDuration.durationValues[0];
    const normalizedChartData: ITrendChartAggregateData[] = JSON.parse(JSON.stringify(succesfulPipelineData));
    const length = normalizedChartData.length;
    for (let i = 0; i < length; i++) {
        normalizedChartData[i].aggrValue = updatedValues[i];
    }

    return normalizedChartData;
}

export function getDurationTrend(chartData: ITrendChartData) {
    const succesfulPipelineData = chartData.primaryChartData[SuccessfulPipelines];
    const len = succesfulPipelineData.length;
    let trend;
    if (len > 0) {
        const startValue = succesfulPipelineData[0].aggrValue;
        const endValue = succesfulPipelineData[len - 1].aggrValue;
        trend = getTrendFromData(startValue, endValue, true);
    }
    return trend;
}
